import React from "react";
import { Button } from "semantic-ui-react";
import {
  MAIN_COLOUR,
  TEAL_PRIMARY_COLOUR,
  WHITE_COLOUR,
} from "../../../css/styles";

export default function BalanceTopUpButton({
  textColour = WHITE_COLOUR,
  currencySymbol,
  amount,
  isDisabled = false,
  isSelected = false,
  fontSize = 16,
  action,
}) {
  const buttonColour = isSelected ? MAIN_COLOUR : TEAL_PRIMARY_COLOUR;

  return (
    <Button
      className={"overwrite-button cta-orange"}
      onClick={action}
      disabled={isDisabled}
      style={{ backgroundColor: buttonColour }}
    >
      <div style={{ color: textColour, fontSize: fontSize }}>
        {currencySymbol}
        {amount}
      </div>
    </Button>
  );
}
